// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kpLf","questions":"styles_questions__2ihMe","footer":"styles_footer__qd27E"};